export default {
    baseURL: '//gz.iot.cloud.tencent.com',
    timeout: 20000
}
